// extracted by mini-css-extract-plugin
export default {"button":"OrderSomethingElseButton_button__b-ZY2","grid":"OrderSomethingElseButton_grid__JCHFd"};